import AOS from "aos";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children, watch }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (AOS) {
      AOS.refresh();
    }
  }, [location, watch]); 

  return <>{children}</>;
};

export default ScrollToTop;